import React from 'react';
import "./Whatsapp.css";

const Wassapht = () => {
  return (<a
    href="https://wa.me/+573138453159"
    class="whatsapp_float"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i class="fa fa-whatsapp whatsapp-icon"></i>
  </a>);


}






export default Wassapht;